import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "Glow & You — Consultation en image personnalisée",
  description = "Révèle ta meilleure version. Un accompagnement personnalisé pour harmoniser ton style, ta personnalité et ta garde-robe.",
  image = "https://customer-assets.emergentagent.com/job_glow-you-luxe/artifacts/c2tw545j_Tu_es_un_photographe_professio_Kling_30_14933.jpg.png",
  url = "https://glowyou.org"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Glow & You" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="fr_CA" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* WhatsApp / iMessage */}
      <meta property="og:image:alt" content="Glow & You - Consultation en image personnalisée" />
    </Helmet>
  );
};

export default SEOHead;
